import { useContext, Fragment } from 'react'
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { BreadcrumbContext } from '../../components/Layout/Layout';

function Sidenav({
  menus,
  ...props
}) {
  const  { currentBreadcrumb } = useContext(BreadcrumbContext);

  const isActiveLink = (linkName) => {
    //return currentBreadcrumb ? linkName?.toLowerCase().includes(currentBreadcrumb[0].linkText?.toLowerCase()) : false;
    return window.location.pathname.toLowerCase().includes(linkName.path?.toLowerCase());
  }

  const toggleDropdownMenu = (event) => {
      let target = event.target;
      if(target.nodeName !== 'BUTTON') target = event.target.parentElement;
        target.classList.toggle("active");
        var dropdownContent = target.nextElementSibling;
        if(!dropdownContent) return;
        if (dropdownContent.style.display === "block") {
          target.querySelector('.dropdown-close').style.display = "block";
          target.querySelector('.dropdown-open').style.display = "none";
          dropdownContent.style.display = "none";
        } else {
          dropdownContent.style.display = "block";
          target.querySelector('.dropdown-close').style.display = "none";
          target.querySelector('.dropdown-open').style.display = "block";
        }
  };

  const generateMenu = () => menus.map((menuItem, index) => {
      return menuItem.submenu ? (
        <Fragment key={`Fragment${index}`}>
          <button className="dropdown-btn" onClick={(event) => toggleDropdownMenu(event)}>
            <img className="sidenav-icons" src={menuItem.iconPath}/>
            {menuItem.name}
            <i className="sidenav-icons-arrow dropdown-close fa fa-angle-right"></i>
            <i className="sidenav-icons-arrow dropdown-open fa fa-angle-down" style={{display: 'none'}}></i>
          </button>
          <div className="dropdown-container">
            {
              menuItem.submenu.map((submenu, subindex) => (
                <Link key={`SubLink${subindex}`} to={submenu.path} className={classNames({'sidenav-active-link': isActiveLink(submenu)})}>{submenu.name}</Link>
              ))
            }
          </div>
        </Fragment>
      ) : (
        <Link key={`Link${index}`} to={menuItem.path} className={classNames({'sidenav-active-menu': isActiveLink(menuItem)})}>
          <img className="sidenav-icons" src={menuItem.iconPath}/>
          {menuItem.name}
        </Link>
      )
    });
  return (
    <div className="sidenav">
      <div className="sidenav-heading">Navigation</div>
      { generateMenu() }
    </div>
  );
};

export default Sidenav;